/* ==========================================================================
   ReflexAme™ — Interactions douces
   Menu mobile, header au scroll, apparitions progressives, validation formulaires
   ========================================================================== */
(function () {
  'use strict';

  /* ----- Header : ombre au scroll ----- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----- Menu mobile ----- */
  var toggle = document.querySelector('.menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileNav.classList.toggle('is-open', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('is-open');
        toggle.focus();
      }
    });
  }

  /* ----- Apparition progressive (IntersectionObserver) ----- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ----- Validation douce des formulaires ----- */
  document.querySelectorAll('form[data-validate], form.js-validate').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var valid = true;
      form.querySelectorAll('[required]').forEach(function (field) {
        var wrapper = field.closest('.form-field') || field.parentElement;
        var existing = wrapper.querySelector('.form-error');
        if (existing) existing.remove();
        wrapper.classList.remove('has-error');

        var value = field.value.trim();
        var invalid = !value;
        if (!invalid && field.type === 'email') {
          invalid = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        }
        if (invalid) {
          valid = false;
          wrapper.classList.add('has-error');
          var msg = document.createElement('p');
          msg.className = 'form-error';
          msg.textContent = field.type === 'email' && value
            ? 'Merci de saisir une adresse email valide.'
            : 'Ce champ est requis.';
          wrapper.appendChild(msg);
        }
      });
      if (!valid) {
        e.preventDefault();
        var firstError = form.querySelector('.has-error input, .has-error textarea');
        if (firstError) firstError.focus();
      }
    });
  });

  /* ----- Quantité produit ----- */
  document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = btn.dataset.dir === 'up' ? 1 : -1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });
  });
})();
